import gql from 'graphql-tag';

export const UPDATE_LOOK_TEXT_SECTION_FILTER = gql`
  mutation updateLookTextSectionFilter($filter: TextSectionFilterInput!, $orderBy: [String]) {
    updateLookTextSectionFilter(filter: $filter, orderBy: $orderBy) @client
  }
`;
